module.exports = __webpack_public_path__ + "media/精工工艺--外立面石材.18fb74a6.mp4";